module.exports = __webpack_public_path__ + "img/voucher.f26ad65a.png";